export const formPage = (target) => {
  const el = {
    errorMessage: target.querySelector('#error-message'),
  }

  const method = {
    init: () => {
      method.scrollToErrorMessage()
    },

    scrollToErrorMessage: () => {
      if (!el.errorMessage) return
      window.scrollTo(0, el.errorMessage.getBoundingClientRect().top)
    },
  }

  method.init()
}
